import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink } from '../Common/Links';
import * as styles from './WebinarCard.module.css';

const WebinarCard = ({
  title,
  description,
  url,
  image,
  ctaLabel,
  usesExternalRegistration,
  externalRegistrationUrl,
}) => {
  const isSvg = get(image, 'file.contentType') === 'image/svg+xml';
  let ctaUrl = usesExternalRegistration ? externalRegistrationUrl : url;
  return (
    <div className={styles.card}>
      {image && (
        <div className={styles.image}>
          {isSvg && <img src={get(image, 'file.url')} alt={get(image, 'title')} />}
          {!isSvg && <GatsbyImage alt={image.title} image={image.gatsbyImageData} />}
        </div>
      )}
      <div>
        <h4>{title}</h4>
        <p>{description}</p>
        <ArrowLink url={ctaUrl} label={ctaLabel} />
      </div>
    </div>
  );
};

WebinarCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default WebinarCard;
